import React from "react"

export default function IconChatE2E() {
   return (
      <svg width="25" height="25" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
         <path d="M16.4004 2.94256L9.65039 0.130056C9.44478 0.0447595 9.22436 0.000854492 9.00176 0.000854492C8.77915 0.000854492 8.55874 0.0447595 8.35313 0.130056L1.60312 2.94256C0.973828 3.20271 0.5625 3.81795 0.5625 4.49998C0.5625 11.4785 4.58789 16.3019 8.34961 17.8699C8.76445 18.0422 9.23203 18.0422 9.64687 17.8699C12.6598 16.6148 17.4375 12.2801 17.4375 4.49998C17.4375 3.81795 17.0262 3.20271 16.4004 2.94256ZM9.00352 15.6902L9 2.29568L15.184 4.87263C15.068 10.1953 12.2977 14.0519 9.00352 15.6902V15.6902Z" fill="#5B5E71" />
      </svg>
   )
}
